import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const SUPPLIERS_CONTRACT_HAS_ENDED =
  "zz_FrameworkAgreementApiErrorCodeSuppliersContractUnderTheFrameworkAgreementHasEnded";

export const isEndedContractRefusal = (e: unknown): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === SUPPLIERS_CONTRACT_HAS_ENDED;
